<template>
  
    <v-toolbar flat app color="white darken-4" light>
      <v-toolbar-side-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-spacer class="hidden-md-and-up"></v-spacer>
      <router-link :to="{name:'home'}">
      <img src="../assets/logo.png" height="40">
        </router-link>
      <v-btn flat class="hidden-sm-and-down">القائمة</v-btn>
      <v-spacer class="hidden-sm-and-down"></v-spacer>
      <v-btn flat class="hidden-sm-and-down">تسجيل الدخول</v-btn>
      <v-btn color="primary " class="hidden-sm-and-down">التسجيل</v-btn>
    </v-toolbar>
</template>

<script>
export default {
  name: "AppToolbar",

};
</script>

<style scoped>
</style>